import type { AdminTicketRow } from '../../../domain/superadmin/types';
import { formatDate, formatDateTime } from '../../../utils/formatters';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../../components/ui/table';
import { TICKET_STATUS_LABELS } from './ticketStatusLabels';

interface AdminTicketsTableProps {
    items: AdminTicketRow[];
    onSelect: (id: string) => void;
}

export function AdminTicketsTable({ items, onSelect }: AdminTicketsTableProps) {
    if (items.length === 0) {
        return (
            <p className="py-12 text-center text-sm text-muted">
                Nenhum ticket encontrado.
            </p>
        );
    }

    return (
        <>
            <ul className="m-0 flex list-none flex-col gap-3 p-0 md:hidden">
                {items.map((row) => (
                    <li key={row.id}>
                        <button
                            type="button"
                            onClick={() => onSelect(row.id)}
                            className="flex w-full flex-col gap-2 rounded-xl border border-subtle bg-card p-4 text-left touch-manipulation transition-colors hover:bg-surface-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                        >
                            <span className="font-medium text-default">{row.subject}</span>
                            <span className="text-sm text-secondary">{row.orgName}</span>
                            <span className="truncate text-xs text-muted">{row.requesterEmail}</span>
                            <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-muted">
                                <span>{TICKET_STATUS_LABELS[row.status]}</span>
                                <time dateTime={row.updatedAt}>{formatDateTime(row.updatedAt)}</time>
                            </div>
                        </button>
                    </li>
                ))}
            </ul>

            <div className="hidden overflow-x-auto md:block">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Assunto</TableHead>
                            <TableHead>Organização</TableHead>
                            <TableHead>Solicitante</TableHead>
                            <TableHead>Status</TableHead>
                            <TableHead>Atualizado em</TableHead>
                            <TableHead>Criado em</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {items.map((row) => (
                            <TableRow
                                key={row.id}
                                className="cursor-pointer"
                                onClick={() => onSelect(row.id)}
                            >
                                <TableCell>
                                    <span className="font-medium text-default">{row.subject}</span>
                                </TableCell>
                                <TableCell>{row.orgName}</TableCell>
                                <TableCell className="text-muted">{row.requesterEmail}</TableCell>
                                <TableCell>{TICKET_STATUS_LABELS[row.status]}</TableCell>
                                <TableCell className="text-muted">
                                    {formatDateTime(row.updatedAt)}
                                </TableCell>
                                <TableCell className="text-muted">
                                    {formatDate(row.createdAt)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </>
    );
}
